<template>
  <Content>
    <template #body>
      <div class="grid">
        <router-link v-if="role !== 'federal_admin'" to="create/regional"
          ><el-button>Создать региональный документ</el-button></router-link
        >
        <router-link v-if="role !== 'regional_admin'" to="create/federal"
          ><el-button>Создать федеральный документ</el-button></router-link
        >
      </div>

      <Table
        :columns="columns"
        :options="columnsOptions"
        :method-fetch-data="methods.fetchData"
        :method-delete-row="methods.deleteRow"
      />
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";
import Table from "@/components/Table";

import {
  getDocuments as fetchData,
  deleteDocuments as deleteRow,
} from "@/api/documents";

import { getDocSection } from "@/api/docSections";
import { getRegions, getMacroregions } from "@/api/regions";
import store from "@/store";
import { mapGetters } from "vuex";

getMacro();

const columnsOptions = {
  sortable: "custom",
  controls: {
    width: 270,
  },
  id: "id",
  edit: {
    name: "type_name",
  },
  delete_row: {
    buttonName: "Удалить",
    confirm: true,
  },
  search_list: [
    {
      name: "macroregionName",
      label: "Поиск по макрорегиону",
      strong: true,
      values: null,
      multiple: false,
      code: "name",
      value_lable: "name",
      value_value: "name",
    },
    {
      name: "type",
      label: "Поиск по типу",
      strong: true,
      values: [
        {
          lable: "Региональные документы",
          code: "regional",
        },
        {
          lable: "Федеральные документы",
          code: "federal",
        },
      ],
      multiple: false,
      code: "code",
      value_lable: "lable",
      value_value: "code",
    },
  ],
};

async function getMacro() {
  const data = await getMacroregions();
  columnsOptions.search_list[0].values = data.macroregions;
}

const midFunc = async (params) => {
  const data = await fetchData(params);
  const documents = data.documents;
  const sections = await getDocSection();
  const regions = await getRegions();
  return documents.map((el) => {
    return {
      ...el,
      section_id: normalizeData(el.section_id, sections),
      type_name: normalizeType(el.section_id, sections),
      regions: normalizeData(el.regions, regions.regions),
    };
  });
};

const normalizeType = (section_id, data) => {
  const find = data.find((el) => el.id == section_id);
  return find.type_id === store.getters.types.regional ? "regional" : "federal";
};

const normalizeData = (data, format) => {
  if (typeof data === "number") {
    const find = format.find((el) => el.id == data);
    return find.name;
  } else {
    const normalData = data.map((el) => {
      const find = format.find((item) => item.id == el.id);
      return find.name;
    });
    return normalData;
  }
};

const columns = [
  {
    prop: "id",
    label: "ID",
  },
  {
    prop: "section_id",
    label: "Секция документа",
  },
  {
    prop: "name",
    label: "Название документа",
  },
  {
    prop: "pdf",
    label: "Ссылка на документ",
    type: "file_link",
    sortable: false,
  },
  {
    prop: "regions",
    label: "Список регионов действия документа",
    type: "list",
    sortable: false,
  },
];

export default {
  components: {
    Content,
    Table,
  },
  data() {
    return {
      columnsOptions: columnsOptions,
      columns: columns,
      methods: {
        fetchData: midFunc,
        deleteRow,
      },
    };
  },
  mounted() {
    if (this.role === "regional_admin") {
      this.columnsOptions.search_list = [
        {
          name: "macroregionName",
          label: "Поиск по макрорегиону",
          strong: true,
          values: null,
          multiple: false,
          code: "name",
          value_lable: "name",
          value_value: "name",
        },
      ];
    } else if (this.role === "federal_admin") {
      this.columnsOptions.search_list = [];
    }
  },
  computed: {
    ...mapGetters(["role"]),
  },
};
</script>

<style lang="scss" scoped>
.grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 16px;
  margin-bottom: 20px;
  button {
    width: 100%;
  }
}
</style>
